import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getAsync } from '../../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../../shared/Helper';
import { useLocation } from 'react-use';

const VideoGalleryDetail = () => {
  const [apiData, setApiData] = useState([]);
  const { id } = useParams();
  const { t } = useTranslation();
  const { pathname } = useLocation();


  const getData = async () => {
    await getAsync('CMSVideoGallery/GetByIdCMSVideoGallery/', { id: id })
      .then((response) => {
        const result = response?.data;
        setApiData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  useEffect(() => {
    getData();
    PageHitCountApi(pathname, 0);
  }, []);

  return (
    <>
      <div className="col-lg-12">
        <div className="header-wrapper" style={ { textAlign: 'center' } }>
          <h1>Video Gallery Detail</h1>
        </div>
        <div style={ { margin: '20px', padding: '20px' } } className="col-lg-10">
          { apiData?.map((item, index) => (
            <div key={ index }>
              {/* <div className="wrapper">
                <img
                  style={{
                    borderRadius: '20px',
                    border: '1px solid black',
                    height: '500px',
                    width: '600px'
                  }}
                  src={`data:image/jpeg;base64,${item?.doc}`}
                  alt="img.jpg"
                />
              </div> */}
              <div className="content-title">
                <h2>{ item?.title }</h2>
                <a href={ item?.link } target="_blank" rel="noopener noreferrer">{ item?.link }</a>
                <p>{ item?.publicationDate }</p>
              </div>
              <div className="content">
                <pre>{ item?.filmingLocation ? item?.filmingLocation : 'N/A' }</pre>
              </div>
            </div>
          )) }
        </div>
      </div>
    </>
  );
};

export default VideoGalleryDetail;
